
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]",
      function () {
        return require("private-next-pages/[publicId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]"])
      });
    }
  